import React, { useState } from "react";
import { MapPin, Loader2 } from "lucide-react";

/**
 * Iter-600 §1 — "📍 Nearest" sort chip. Browser location is requested
 * ONLY when tapped; denial keeps the current sort with a quiet note.
 * Tapping while active clears the nearest sort.
 */
export default function NearestChip({ active, onCoords, onClear, testId = "nearest-chip" }) {
  const [state, setState] = useState("idle"); // idle | locating | denied

  const tap = () => {
    if (active) {
      onClear?.();
      return;
    }
    if (!navigator.geolocation) {
      setState("denied");
      return;
    }
    setState("locating");
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setState("idle");
        onCoords({ lat: pos.coords.latitude.toFixed(5), lng: pos.coords.longitude.toFixed(5) });
      },
      () => setState("denied"),
      { timeout: 10_000, maximumAge: 300_000 },
    );
  };

  return (
    <span className="inline-flex items-center gap-1.5">
      <button
        type="button"
        data-testid={testId}
        onClick={tap}
        className={`inline-flex items-center gap-1 rounded-full border px-3 py-1.5 text-xs font-bold transition-colors ${
          active
            ? "bg-[color:var(--brand-blue)] text-white border-[color:var(--brand-blue)]"
            : "bg-white border-soft text-slate-700 hover:border-[color:var(--brand-blue)]"
        }`}
      >
        {state === "locating" ? <Loader2 className="w-3 h-3 animate-spin" /> : <MapPin className="w-3 h-3" />}
        Nearest
      </button>
      {state === "denied" && (
        <span className="text-[10px] text-slate-400" data-testid={`${testId}-denied`}>
          Location off — keeping current sort
        </span>
      )}
    </span>
  );
}
